module.exports = __webpack_public_path__ + "img/RegistrationHome.87af8624.jpg";